export const MODAL_NAMES = {
  SWAP_PRODUCT: 'SWAP_PRODUCT',
  SWAP_ATC: 'SWAP_ATC',
  SWAP_CART: 'SWAP_CART',
  SWAP_CHECKOUT_SUMMARY: 'SWAP_CHECKOUT_SUMMARY',
  SWAP_MIX_AND_MATCH: 'SWAP_MIX_AND_MATCH',
  SWAP_LISTING: 'SWAP_LISTING',
  SWAP_LISTING_MOBILE: 'SWAP_LISTING_MOBILE',
  SWAP_VIEW_OFFER: 'SWAP_VIEW_OFFER',
  SWAP_VIEW_OFFER_MOBILE: 'SWAP_VIEW_OFFER_MOBILE',
  SWAP_SUMMARY: 'SWAP_SUMMARY',
  SWAP_PP_VIEW_OFFER: 'SWAP_PP_VIEW_OFFER',
  MY_SALES_SHIP_ITEM: 'MY_SALES_SHIP_ITEM',
  MY_SALES_KYC_DETAILS: 'MY_SALES_KYC_DETAILS',
  MY_SALES_COUNTER_OFFER: 'MY_SALES_COUNTER_OFFER',
  MY_SALES_CONFIRM_COUNTER_OFFER: 'MY_SALES_CONFIRM_COUNTER_OFFER',
  SWAP_REMOVE_CART: 'SWAP_REMOVE_CART',
  GRADING_WITH_IA: 'GRADING_WITH_IA',
}

export const ROUTE_NAMES = {
  DEVICE_ASSESSMENT: 'buyback_device_form',
  OFFER: 'buyback_offer',
  NO_OFFER: 'buyback_no_offer',
  BANK: 'buyback_bank',
  ADDRESS: 'buyback_address',
  CONFIRMATION: 'buyback_confirmation',
  SHIPPING: 'buyback_shipping',
  CONVERSATION: 'buyback_conversation',
  TRADE_IN_PRODUCT: 'trade_in_product',
}

export const ERROR_TYPES = {
  INVALID_ID_ERROR_TYPE: '/errors/buyback/order/invalid-listing-id',
  NOT_FOUND_ERROR_TYPE:
    '/errors/buyback/order/creation/buyback-listing-not-found',
}

export const STEP_NAMES = {
  BANK: 'bank',
  ADDRESS: 'address',
  SHIPPING: 'shipping',
}

export const BUYBACK_PARTNERS = {
  PLAYSTATION: 'playstation',
}

export const FUNNEL_ERROR_MESSAGE = {
  GET_CATEGORIES:
    '[BUYBACK][API][FUNNEL] Error getting questions API (categories)',
  GET_QUESTIONS: '[BUYBACK][API][FUNNEL] Error getting questions API',
  EMPTY_QUESTIONS: '[BUYBACK][API][FUNNEL] Empty response from questions API',
  POST_QUESTIONS: '[BUYBACK][API][FUNNEL] Error posting questions API',
  GET_OFFER: '[BUYBACK][API][FUNNEL] Error getting offer',
  POST_ORDER: '[BUYBACK][API][FUNNEL] Error posting buyback order',
  ADD_SWAP: '[BUYBACK][API][FUNNEL] Error adding buyback to cart',
  GET_ADDRESS: '[BUYBACK][API][FUNNEL] Error getting address',
  POST_ADDRESS: '[BUYBACK][API][FUNNEL] Error posting address',
  POST_BANK: '[BUYBACK][API][FUNNEL] Error posting bank details',
  GET_TAX_IDENTIFICATION:
    '[BUYBACK][API][FUNNEL] Error getting tax identification info',
  PUT_TAX_IDENTIFICATION:
    '[BUYBACK][API][FUNNEL] Error updating tax identification number',
  BUYBACK_FUNNEL: '[BUYBACK][JS][FUNNEL] Error JS in buyback funnel',
  GET_SALE_DETAILS: '[BUYBACK][API][FUNNEL] Error getting sale details',
  GET_CONFIRMATION_DETAILS:
    '[BUYBACK][API][FUNNEL] Error getting confirmation details',
  GET_SHIPPING_DETAILS: '[BUYBACK][API][FUNNEL] Error getting shipping details',
  PRODUCT_NOT_FOUND: '[BUYBACK][API][PRODUCT] Product not found',
}
